import { render } from "./SVGArrowTooltipDown.vue?vue&type=template&id=c9e13576"
import script from "./SVGArrowTooltipDown.vue?vue&type=script&lang=js"
export * from "./SVGArrowTooltipDown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__